import Vue from 'vue'
import VModal from 'vue-js-modal'
import i18n from '../plugins/i18n'

Vue.use(VModal, {dynamic: true});

new Vue({
    i18n,
    el: '#login',
    components: {
        'change-password-modal': () => import(/* webpackPrefetch: true */'../Modals/ChangePasswordModal')
    },

    data() {
        return {
            token: localStorage.getItem('accessToken') || '',
            accountFullName: localStorage.getItem('accountFullName') || '',
            identificator: null,
            password: null,
            resetPasswordForm: {clientId: null},
            resetPasswordSuccess: false
        }
    },

    mounted() {
        this.changeAccountFullNameHandler = (event) => {
            this.accountFullName = event.detail.storage;
        }
        window.addEventListener('accountFullName-localstorage-changed', this.changeAccountFullNameHandler)
    },

    created() {
        const translateEl = document.getElementById('translates-login')
        this.$i18n.setLocaleMessage('cs', JSON.parse(translateEl.innerHTML))
        
    },

    beforeDestroy() {
        window.removeEventListener('accountFullName-localstorage-changed', this.changeAccountFullNameHandler);
    },

    methods: {
        async login () {
            const {identificator, password} = this
            if (identificator && password) {
                const payload = {
                    'grant_type': 'client_credentials',
                    'client_id': identificator,
                    'client_secret': password
                }
                try {
                    const {default: axios} = await import('axios')
                    const {API_URL} = await import('../utils/consts')
                    const response = await axios.post(`${API_URL}/token`, payload, {headers: {'content-type': 'application/json'}})
                    this.setAccessToken(response.data.access_token)
                    window.location = '/contact/detail'
                } catch (e) {
                    const {ErrorModal} = await import(/* webpackPrefetch: true */'../Modals/ErrorModal')
                    if (e.response && e.response.data['errors'] && e.response.data['errors']['code'] === 1006) {
                        this.$modal.show('change-password-dialog')
                    } else {
                        ErrorModal.show(this, this.$i18n.t(e.response && e.response.data['error'] ? `error.${e.response.data['error']}` : 'error.somethingWrong'))
                    }
                }
            }
        },

        logout() {
            this.token = null;
            localStorage.removeItem('accessToken')
            localStorage.removeItem('accountFullName')
            this.accountFullName = null
            window.location = '/'
        },

        setAccessToken(token) {
            if (token) {
                localStorage.setItem('accessToken', token)
                this.token = token
            }
        },

        navigateToClientZone() {
            window.location = '/contact/detail'
        },

        isInClientZone() {
            return window.location.pathname.includes('/contact/detail')
        },

        openResetPasswordDialog() {
            this.$modal.show('reset-password-dialog')
        },

        closeResetPasswordDialog() {
            this.$modal.hide('reset-password-dialog')
        },

        async resetPassword() {
            if (this.resetPasswordForm.clientId) {
                try {
                    const {default: axios} = await import('axios')
                    const {API_URL} = await import('../utils/consts')
                    const {data: {records: {message}}} = await axios.post(`${API_URL}/renewPassword/createToken`, {client_id: this.resetPasswordForm.clientId}, {headers: {'content-type': 'application/json'}})
                    this.resetPasswordSuccess = message
                } catch (e) {
                    const {ErrorModal} = await import(/* webpackPrefetch: true */'../Modals/ErrorModal')
                    ErrorModal.show(this, this.$i18n.t(e.response.data.errors ? `error.${e.response.data.errors.message}` : 'error.somethingWrong'))
                }
            }
        }
    }
});
